import React from 'react';
import Logo from '../../LogoJMM';
import CircularProgress from '@material-ui/core/CircularProgress';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var JmmLoader = function JmmLoader(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 9999 : _ref$zIndex,
    _ref$backdrop = _ref.backdrop,
    backdrop = _ref$backdrop === void 0 ? true : _ref$backdrop,
    _ref$fullPage = _ref.fullPage,
    fullPage = _ref$fullPage === void 0 ? false : _ref$fullPage;
  var width = fullPage ? '100vw' : '100%';
  var height = fullPage ? '100vh' : '100%';
  var paddingTop = fullPage ? '50vh' : '50%';
  var outerDivStyle = {
    width: width,
    height: height,
    zIndex: zIndex,
    paddingTop: paddingTop,
    marginTop: fullPage ? '-70px' : '0',
    position: fullPage ? 'fixed' : 'relative',
    backdropFilter: backdrop ? 'blur(8px)' : 'inherit',
    backgroundColor: backdrop ? 'rgba(255, 255, 255, 0.6)' : 'transparent',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    gap: '1rem'
  };
  var innerDivStyle = {
    width: '150px',
    height: '150px',
    margin: '0 auto',
    borderRadius: '50%',
    transform: 'scale(1)',
    animation: 'pulse 2s infinite',
    textAlign: 'center'
  };
  var textStyle = {
    padding: '16px',
    margin: '0 auto',
    fontSize: '18px',
    marginTop: '20px',
    maxWidth: '400px',
    color: 'darkgray',
    fontWeight: 'bold',
    textAlign: 'center'
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      style: outerDivStyle,
      children: [/*#__PURE__*/_jsxs("div", {
        style: innerDivStyle,
        children: [/*#__PURE__*/_jsx(Logo, {
          width: "150",
          height: "150",
          variant: "circleFull",
          globalThemeVariant: "jmm"
        }), /*#__PURE__*/_jsx(CircularProgress, {
          style: {
            color: '#74C4F6',
            marginTop: '8px'
          }
        })]
      }), text && /*#__PURE__*/_jsx("div", {
        style: textStyle,
        children: text
      })]
    })
  });
};
export default JmmLoader;